import React, { useEffect, useState } from 'react';
import Flex from '../../../../../components/Flex';
import styles from './styles.module.scss';
import bellIcon from '../../../../../assets/images/bell-icon/image.png';
import bgIcon from '../../../../../assets/images/background/image.png';
import DateRangePicker from 'react-daterange-picker';
import './styles.css';
import moment from 'moment';
import strings from '../../../../../globalization';
import calendarBlue from '../../../../../assets/images/calendar-blue-icon/image.png';
import Button from '../../../../../components/Button';
import { AgGridReact } from 'ag-grid-react';
import dimensions from '../../.../../../../../util/dimensions-util';
import { dummyData } from '../../data';
import TextInput from '../../../../../components/TextInput';
import { customStyles } from './customStyles';
import Select from 'react-select';
import TableTimestamp from '../../../../../components/TableTimestamp';
import ReactTooltip from 'react-tooltip';
import { commonImages } from '../../../../../assets/images';
const { vw: widthConstant, vh: heightConstant } = dimensions;

const STATUS_CONSTANTS_TRANSLATE = {
  OPERATOR_ADMIN_APPROVED: 'Pending',
  DEPARTMENT_ADMIN_APPROVED: 'Approved',
  DEPARTMENT_ADMIN_REJECTED: 'Rejected',
};
const STATUS_CONSTANTS = {
  OPERATOR_ADMIN_APPROVED: 'OPERATOR_ADMIN_APPROVED',
  DEPARTMENT_ADMIN_APPROVED: 'DEPARTMENT_ADMIN_APPROVED',
  DEPARTMENT_ADMIN_REJECTED: 'DEPARTMENT_ADMIN_REJECTED',
};

const Desktop = ({
  onChange,
  dates,
  onClick,
  personsAndVehicles,
  searchText,
  filteredPersonsAndVehicles,
  statuses,
  selectedStatus,
  entityTypeOptions,
  selectedEntity,
  timestamp,
  componentType,
  user
}) => {
  const [gridAPI, setGridAPI] = useState(null);
  const [selectAllButtonText, setSelectAllButtonText] = useState('Approve');

  useEffect(() => {
    console.log(gridAPI);
    if (gridAPI) {
      // gridApi.setRowHeight(50);
    }
    if (gridAPI && filteredPersonsAndVehicles.length > 10) {
      console.log('changing to normal');
      gridAPI.setDomLayout('normal');
    } else if (gridAPI) {
      console.log('changing to autoHeight');
      gridAPI.setDomLayout('autoHeight');
    }
  }, [gridAPI, filteredPersonsAndVehicles]);

  const getRowStyle = params => {
    if (params.node.rowIndex % 2 === 0) {
      return { background: '#f6f6f6', border: 'none' };
    }
  };
  const rowStyle = { border: 'none', cursor: 'pointer' };

  const onGridReady = params => {
    console.log(params.api);
    setGridAPI(params.api);
  };
  const columnDefs = [
    {
      headerName: '',
      field: 'checkBox',
      headerClass: styles.rowHeader,
      width: 100 * widthConstant,
      resizable: true,
      checkboxSelection: function (params) {
        const displayedColumns = params.columnApi.getAllDisplayedColumns();
        return displayedColumns[0] === params.column;
      },
      headerCheckboxSelection: true,
    },
    {
      headerName: 'Type',
      field: 'type',
      headerClass: styles.rowHeader,
      width: 140 * widthConstant,
      resizable: true,
      cellStyle: { display: 'flex', alignItems: 'center' },
      cellRendererFramework: ({ data: { type } }) => {
        return <div className={styles.typeText}>{type}</div>;
      },
    },
    {
      headerName: 'Name / Registration Number',
      field: 'nameOrRegistrationNumber',
      headerClass: styles.rowHeader,
      minWidth: 300 * widthConstant,
      resizable: true,
      wrapText: true,
      flex: 1,
      autoHeight: true,
      cellStyle: { display: 'flex', alignItems: 'center', lineHeight: 1.5 },
      cellRendererFramework: ({ data }) => {
        return (
          <div className={styles.sessionTime}>
            {data.name ? data.name : data.vehicleRegistrationNumber}
          </div>
        );
      },
    },
    {
      headerName: 'Reference Numbers',
      field: 'referenceId',
      headerClass: styles.rowHeader,
      width: 230 * widthConstant,
      resizable: true,
      wrapText: true,
      autoHeight: true,
      cellStyle: { display: 'flex', alignItems: 'center' },
      cellRendererFramework: ({ data: { referenceId } }) => {
        return <div className={styles.sessionTime}>{referenceId}</div>;
      },
    },
    {
      headerName: 'Registered On',
      field: 'registeredOn',
      headerClass: styles.rowHeader,
      wrapText: true,
      autoHeight: true,

      resizable: true,
      width: 190 * widthConstant,
      cellRendererFramework: ({ data: { createdDate } }) => {
        return (
          <div className={styles.sessionTime}>
            {moment(createdDate).format('DD/MM/YYYY')}
          </div>
        );
      },
    },
    {
      headerName: 'Updated By',
      field: 'updatedBy',
      headerClass: styles.rowHeader,
      wrapText: true,
      autoHeight: true,

      resizable: true,
      width: 250 * widthConstant,
      cellStyle: { display: 'flex', alignItems: 'center', lineHeight: 1.5 },
      cellRendererFramework: ({ data }) => {
        return (
          <div className={styles.sessionTime}>
            {data.updatedBy ? data.updatedBy : '-'}
          </div>
        );
      },
    },
    {
      headerName: 'View Details',
      field: 'viewDetails',
      headerClass: styles.rowHeader,
      // flex: 1,
      width: 200 * widthConstant,
      autoHeight: true,

      resizable: true,
      cellStyle: { display: 'flex', alignItems: 'center' },
      cellRendererFramework: ({ data: { } }) => {
        return <div className={styles.viewButton}>{`View`}</div>;
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      headerClass: styles.rowHeader,
      resizable: true,
      autoHeight: true,
      width: 150,
      cellStyle: { display: 'flex', alignItems: 'center' },
      cellRendererFramework: ({ data: { status } }) => {
        return (
          <div className={styles.statusStyles} style={getStatusStyles(status)}>
            {STATUS_CONSTANTS_TRANSLATE[status]}
          </div>
        );
      },
    },
  ];
  const getStatusStyles = status => {
    switch (status) {
      case STATUS_CONSTANTS.OPERATOR_ADMIN_APPROVED:
        return { background: '#0045e670', color: '#000' };
      case STATUS_CONSTANTS.DEPARTMENT_ADMIN_APPROVED:
        return { background: '#0045e670', color: '#000' };
      case STATUS_CONSTANTS.DEPARTMENT_ADMIN_REJECTED:
        return { background: '#e6771770', color: '#000' };
      default:
        return { background: '#2f9e5e', color: '#fff' };
    }
  };
  const onCellClick = (event, index) => {
    onClick('rowClick', event.data);
  };

  const handleAdd = () => {
    let selectedNodes = gridAPI.getSelectedNodes();
    let selectedData = selectedNodes.map(node => node.data);
    onClick('approve-all', selectedData);
    console.log('selectedNodes...', selectedData);
  };

  const handleSelectionChange = event => {
    let localGridAPI = event.api;
    let selectedNodes = localGridAPI.getSelectedNodes();

    let selectedData = selectedNodes.map(node => node.data);

    if (selectedData.length > 1) {
      setSelectAllButtonText('Approve All');
    } else {
      setSelectAllButtonText('Approve');
    }
  };
  const getColumnDefs = () => {
    console.log('selectedStatus...', selectedStatus);
    if (
      selectedStatus &&
      (selectedStatus.id === STATUS_CONSTANTS.DEPARTMENT_ADMIN_APPROVED ||
        selectedStatus.id === STATUS_CONSTANTS.DEPARTMENT_ADMIN_REJECTED)
    ) {
      return columnDefs;
    } else {
      return columnDefs.filter(el => el.field !== 'updatedBy');
    }
  };

  return (
    <div className={styles.agencyContainer}>
      <Header />
      <FiltersRow
        searchText={searchText}
        onChange={onChange}
        dates={dates}
        onClick={onClick}
        statuses={statuses}
        selectedStatus={selectedStatus}
        entityTypeOptions={entityTypeOptions}
        selectedEntity={selectedEntity}
      />
      <TableTimestamp timestamp={timestamp}>
        <div
          className={[
            'ag-theme-balham',
            styles.tableWrapper,
            filteredPersonsAndVehicles?.length > 10
              ? styles.tableWrapperNormal
              : styles.tableWrapperAutoHeight,
          ].join(' ')}>
          {' '}
          <AgGridReact
            rowStyle={rowStyle}
            getRowStyle={getRowStyle}
            rowHoverHighlight={true}
            columnDefs={getColumnDefs()}
            rowHeight={70 * heightConstant}
            headerHeight={70 * heightConstant}
            defaultColDef={{ sortable: true }}
            rowClass={[styles.gridRowClass]}
            onCellClicked={(event, index) => onCellClick(event, index)}
            rowData={filteredPersonsAndVehicles}
            onGridReady={onGridReady}
            rowSelection={'multiple'}
            rowMultiSelectWithClick={true}
            onSelectionChanged={handleSelectionChange}
            pagination={true}
            paginationPageSize={100}
            domLayout="normal"></AgGridReact>
        </div>
        <div className={styles.bottomLabel}>
          {' '}
          Showing {filteredPersonsAndVehicles.length}
        </div>
      </TableTimestamp>
      {STATUS_CONSTANTS[selectedStatus?.id] ===
        STATUS_CONSTANTS.OPERATOR_ADMIN_APPROVED &&
        componentType !== 'VIEW' && user?.roleId !== 10 && (
          <Flex direction="row" style={{ justifyContent: 'center' }}>
            <button onClick={handleAdd} className={styles.approveAll}>
              {selectAllButtonText}
            </button>
          </Flex>
        )}
      <Flex direction="row" style={{ justifyContent: 'center' }}>
        <p className={styles.poweredBySanna}>
          Powered by &nbsp;
          <svg
            width="76px"
            height="23px"
            viewBox="0 0 76 23"
            version="1.1"
            style={{ marginBottom: '5px' }}
            xmlns="http://www.w3.org/2000/svg">
            <title>saññã Logo-01</title>
            <g
              id="Web"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
              opacity="0.349001203">
              <g
                id="Agency_User-Management_delete-user-_message"
                transform="translate(-1146.000000, -1165.000000)"
                fill-rule="nonzero"
                stroke-width="0.64">
                <g id="Group-2" transform="translate(1049.000000, 1166.000000)">
                  <g
                    id="saññã-Logo-01"
                    transform="translate(97.600000, 0.000000)">
                    <path
                      d="M3.03340717,20.2223886 C2.19027944,19.8825254 1.45224629,19.3383545 0.890681636,18.6425016 C0.370570703,17.9938827 0.060688518,17.2112689 0,16.3930669 L4.03733261,16.3930669 C4.07783942,16.8283141 4.31354239,17.2246637 4.6824406,17.4778571 C5.09150306,17.7628087 5.58684015,17.9088348 6.09098999,17.8930995 C6.59995092,17.8930995 6.99439564,17.7972744 7.27432416,17.6043955 C7.53691264,17.4398473 7.69430246,17.1572336 7.69167212,16.8549934 C7.69167212,16.486435 7.49317736,16.2124733 7.09491543,16.0355653 C6.46783144,15.7882293 5.82048131,15.5918035 5.15959147,15.4483289 C4.34822797,15.2747615 3.55023355,15.0473534 2.77129229,14.7677244 C2.1312636,14.529446 1.56277923,14.1410063 1.11716925,13.6374787 C0.655711337,13.1231349 0.42498238,12.4269691 0.42498238,11.5489811 C0.420392996,10.8294689 0.64225162,10.1255795 1.06118355,9.53050965 C1.48446939,8.92443585 2.10625,8.44571945 2.92652537,8.09436045 C3.74680075,7.74300145 4.72230921,7.56609342 5.85305075,7.56363636 C7.52498742,7.56363636 8.8427721,7.96331746 9.80640481,8.76267966 C10.7700375,9.56204186 11.3214119,10.6230805 11.4605278,11.9457956 L7.69167212,11.9457956 C7.64403466,11.52776 7.42442417,11.1457375 7.08219141,10.885576 C6.74288412,10.624309 6.29330196,10.4932661 5.73344493,10.492447 C5.25502165,10.492447 4.88856978,10.5821296 4.63408931,10.7578091 C4.38652114,10.921357 4.24257046,11.1956248 4.25236861,11.4850976 C4.25236861,11.853656 4.45510471,12.1300748 4.86057693,12.314354 C5.26604914,12.4986332 5.89928137,12.6833219 6.76027361,12.8684201 C7.58054751,13.0631756 8.38787528,13.305638 9.17783805,13.5944802 C9.81321276,13.8421337 10.3756361,14.2370647 10.8154199,14.7443824 C11.2845122,15.2751064 11.527541,15.9864241 11.5445064,16.8783354 C11.5546551,17.6014209 11.3240589,18.3085444 10.8866744,18.8955784 C10.448968,19.4877289 9.8199771,19.9529314 8.99970173,20.2911861 C8.0937424,20.6450778 7.12279816,20.8176917 6.14570329,20.7985682 C5.07802192,20.818001 4.01792156,20.6217446 3.03340717,20.2223886 Z"
                      id="Path"
                      stroke="#000000"
                      fill="#000000"></path>
                    <path
                      d="M23.3792048,9.29705436 C23.3792048,8.88829041 23.3880899,8.5241189 23.3792048,8.16118606 C23.3792048,8.01254463 23.4236302,7.98900973 23.5619836,7.99024841 C24.8422817,7.99520313 26.1225799,7.99520313 27.402878,7.99024841 C27.5539244,7.99024841 27.5793103,8.03236348 27.5793103,8.16737945 C27.5742332,10.8627441 27.5742332,13.5576959 27.5793103,16.2522348 C27.5793103,17.5714276 27.5793103,18.8906203 27.5793103,20.209813 C27.5793103,20.3534997 27.5425007,20.3844667 27.4003394,20.383228 C26.1191951,20.3766217 24.8384738,20.3766217 23.5581757,20.383228 C23.4122065,20.383228 23.3753969,20.348545 23.3804741,20.2085743 C23.3918977,19.8369708 23.3804741,19.477754 23.3804741,19.0813768 C23.2535443,19.2287796 23.1520005,19.3600795 23.0364944,19.4789926 C22.4349691,20.0778901 21.6556616,20.4769945 20.8088772,20.6198156 C18.5444504,21.0620239 16.4348779,20.7164326 14.5893193,19.2919522 C13.2654419,18.2675649 12.531788,16.887677 12.2791977,15.268724 C12.0608786,13.8640624 12.2144636,12.4953226 12.873229,11.2170062 C13.8353565,9.35155622 15.4207092,8.24417753 17.4769712,7.77347965 C18.7315807,7.46084092 20.0509284,7.49817904 21.2848638,7.88124469 C22.1130722,8.13674665 22.8430015,8.6301911 23.3792048,9.29705436 Z M19.8695971,17.3360786 C20.193176,17.3430546 20.5163823,17.3105982 20.8317246,17.2394617 C22.1251388,16.9347467 22.9539901,16.1395151 23.277661,14.8958817 C23.6013318,13.6522484 23.2002338,12.5857461 22.189873,11.7892757 C21.1300095,10.9531677 19.8924444,10.8676989 18.6282241,11.2281543 C16.9222882,11.714955 15.9715843,13.6138494 16.5871936,15.2241316 C17.0999898,16.5470403 18.3159769,17.3360786 19.8695971,17.3360786 Z"
                      id="Shape"
                      stroke="#000000"
                      fill="#000000"></path>
                    <path
                      d="M70.2011217,9.29939236 C70.2011217,8.87968785 70.2011217,8.50826794 70.2011217,8.13684803 C70.2011217,8.01304139 70.2341338,7.99199427 70.3509456,7.99323233 C71.6511124,7.99323233 72.9517023,7.99323233 74.2527155,7.99323233 C74.3796849,7.99323233 74.4,8.02542206 74.4,8.14056223 C74.4,12.1717063 74.4,16.2024378 74.4,20.2327565 C74.4,20.3491347 74.3733364,20.3800864 74.2514458,20.3788483 C72.9512791,20.3738961 71.6511124,20.3738961 70.3509456,20.3788483 C70.2328641,20.3788483 70.1973127,20.354087 70.2011217,20.2352326 C70.2100096,19.8638127 70.2011217,19.4824883 70.2011217,19.0553554 C69.8068645,19.6129323 69.2550676,20.0469005 68.6127345,20.3045643 C67.6675498,20.6910238 66.6423581,20.8551589 65.6200656,20.783696 C64.2805383,20.7193166 63.0222715,20.3850387 61.9011317,19.645913 C60.3648019,18.6331747 59.4607797,17.2131126 59.1344683,15.4439158 C58.8652932,13.9780452 59.0074989,12.5493166 59.7007519,11.2097288 C60.6593709,9.35262921 62.24014,8.2519882 64.2906959,7.77657072 C65.5451025,7.46080505 66.8654573,7.49685407 68.0997781,7.88056829 C68.9324729,8.13298744 69.665843,8.62815785 70.2011217,9.29939236 L70.2011217,9.29939236 Z M66.6954964,17.333205 C67.0191764,17.3401775 67.3424838,17.3077372 67.6579245,17.2366359 C68.9517428,16.9320715 69.780853,16.1372329 70.1033553,14.8929762 C70.4258576,13.6487195 70.025904,12.5852205 69.0152275,11.7891438 C67.955033,10.9546871 66.7170812,10.8680224 65.452466,11.2295378 C63.7459972,11.7160979 62.7949963,13.6152917 63.4120676,15.2235399 C63.9212149,16.5457948 65.1375818,17.333205 66.6954964,17.333205 Z"
                      id="Shape"
                      stroke="#000000"
                      fill="#000000"></path>
                    <path
                      d="M33.402212,9.89504156 C33.6226857,9.60646563 33.8749886,9.34217884 34.1546206,9.10689507 C34.7747517,8.62240428 35.5279185,8.32585492 36.3203033,8.25418635 C37.2724141,8.13133099 38.2402685,8.19679955 39.1656618,8.44665489 C40.841025,8.91929915 41.806616,10.0302568 42.1752962,11.6589305 C42.2828978,12.1440076 42.3350463,12.639141 42.330794,13.1353347 C42.330794,15.6236199 42.330794,18.1127173 42.330794,20.6026268 C42.330794,20.7682959 42.2869035,20.8011861 42.1226276,20.8 C40.8686133,20.792659 39.614599,20.792659 38.3605846,20.8 C38.2088489,20.8 38.1762445,20.7597688 38.1762445,20.6184628 C38.1812606,18.4834426 38.1812606,16.3480163 38.1762445,14.212184 C38.183884,13.8213256 38.1447471,13.4309286 38.0596212,13.0488457 C37.8614869,12.2351179 37.3222608,11.7673463 36.470785,11.6638031 C36.0906059,11.6147714 35.7047398,11.626292 35.328378,11.6979114 C34.4142016,11.8757621 33.8900236,12.4020052 33.7282557,13.2973493 C33.6746138,13.6092881 33.649019,13.9251699 33.6517608,14.2414197 C33.6517608,16.3646644 33.6517608,18.486691 33.6517608,20.6099357 C33.6517608,20.7646414 33.6153944,20.8011861 33.4561346,20.8 C32.1971042,20.792659 30.9380738,20.792659 29.6790435,20.8 C29.5360858,20.8 29.5022274,20.7682959 29.5034483,20.628208 C29.5034483,16.6813848 29.5034483,12.7337495 29.5034483,8.78530207 C29.5034483,8.65008683 29.5298158,8.61110586 29.6777894,8.61232402 C30.8532189,8.61963295 32.0286483,8.61963295 33.2040777,8.61232402 C33.3432733,8.61232402 33.3884178,8.63790528 33.3834018,8.7816476 C33.3934339,9.13734896 33.402212,9.49426846 33.402212,9.89504156 Z"
                      id="Path"
                      stroke="#000000"
                      fill="#000000"></path>
                    <path
                      d="M48.7837884,9.9048923 C49.3240882,9.14214798 50.1318216,8.59644357 51.056153,8.36968365 C51.7222326,8.2161808 52.4086137,8.16276189 53.0913685,8.21128911 C53.9333104,8.25515221 54.7489023,8.41720201 55.4967374,8.81440679 C56.6586422,9.43214551 57.2847659,10.4215022 57.5658314,11.6447954 C57.6748711,12.129804 57.7278983,12.6251033 57.7239307,13.1215199 C57.7239307,15.6184678 57.7239307,18.1141972 57.7239307,20.6087081 C57.7239307,20.7646658 57.686288,20.8 57.5269339,20.8 C56.2721771,20.7926895 55.0128195,20.7926895 53.7488611,20.8 C53.6058188,20.8 53.5719404,20.7683211 53.5719404,20.6294213 C53.5769594,18.4939379 53.5769594,16.3580484 53.5719404,14.2217528 C53.5797713,13.8309275 53.5414605,13.4405179 53.4577575,13.0581621 C53.2582512,12.2320737 52.7249796,11.7702926 51.8579426,11.6618533 C51.4396255,11.6083084 51.0148594,11.6268693 50.6031858,11.7166822 C49.7838296,11.8982267 49.2743983,12.4477339 49.1225727,13.3006276 C49.069936,13.6127421 49.04475,13.9286404 49.0472873,14.2449028 C49.0472873,16.3690142 49.0472873,18.4923134 49.0472873,20.6148002 C49.0472873,20.7573553 49.0146636,20.7975632 48.862838,20.7963447 C47.5972067,20.7898465 46.331157,20.7898465 45.0646891,20.7963447 C44.9329397,20.7963447 44.8965517,20.7695395 44.8965517,20.6355134 C44.8965517,16.682148 44.8965517,12.7275643 44.8965517,8.77176211 C44.8965517,8.64992015 44.9203921,8.60605705 45.0596701,8.60727546 C46.243324,8.6137737 47.4261415,8.6137737 48.6081224,8.60727546 C48.7335981,8.60727546 48.7825336,8.62920702 48.7787693,8.76567001 C48.7762598,9.1263222 48.7837884,9.48575597 48.7837884,9.9048923 Z"
                      id="Path"
                      stroke="#000000"
                      fill="#000000"></path>
                    <path
                      d="M56.7494228,0 C56.9171264,0.540340824 57.083444,1.07387063 57.2483757,1.60967077 C57.4008335,2.10801031 57.5505194,2.60634986 57.7057492,3.1046894 C57.7373186,3.16266662 57.7277529,3.23013192 57.6808015,3.28064072 C57.2317439,3.71995143 56.7896162,4.16380282 56.2116624,4.50094825 C55.2567219,5.06058696 54.2075348,5.12983232 53.1029085,4.89825768 C52.498588,4.76181288 51.9143675,4.57147937 51.3607312,4.33067278 C50.5605123,3.98627918 49.6934439,3.75813643 48.7980536,3.65638192 C47.7682702,3.5519463 46.9533137,3.8187112 46.3393245,4.49754274 C46.1840947,4.66895338 46.0413387,4.84603987 45.8736351,5.04242424 C45.7488968,4.63716862 45.6310885,4.24780538 45.5118942,3.86979384 C45.315085,3.23863943 45.1182758,2.60672825 44.9214666,1.97406028 C44.8882468,1.91657479 44.8882468,1.8499186 44.9214666,1.79243311 C45.3968578,1.16241387 45.9664957,0.61526203 46.8105578,0.298549657 C47.7641122,-0.0612991691 48.7398424,-0.0261089054 49.7211165,0.190708526 C50.7023906,0.407525957 51.6448572,0.758293425 52.5942537,1.06024859 C52.991183,1.19549989 53.4015532,1.30259888 53.8208463,1.38036647 C54.6358027,1.51885719 55.2816696,1.25436263 55.8485355,0.812781575 C56.0976382,0.6078513 56.3322507,0.391438426 56.5512276,0.164599621 C56.5988475,0.0966468622 56.6671255,0.0399425138 56.7494228,0 Z"
                      id="Path"
                      stroke="#01F9F4"
                      fill="#01F9F4"></path>
                    <path
                      d="M71.5431925,0 C71.8383455,0.951955429 72.1000849,1.87677674 72.4189058,2.78803098 C72.5358533,3.1272075 72.480164,3.35332518 72.1822266,3.5952711 C71.85366,3.86435113 71.5585071,4.16056529 71.190958,4.40025003 C70.1982973,5.04581601 69.0803358,5.15661367 67.8788403,4.90223128 C67.2328093,4.7494078 66.6080613,4.54253179 66.014643,4.28493002 C65.2507464,3.96732265 64.4259434,3.75743751 63.5754541,3.66423699 C62.5340653,3.55117815 61.7098645,3.82364995 61.0889294,4.50765593 C60.9385685,4.67385243 60.7979532,4.84683245 60.6294932,5.04242424 C60.573804,4.86492186 60.5250759,4.70324772 60.4749555,4.55401006 C60.206719,3.6955166 59.9375544,2.83740001 59.6674615,1.97966028 C59.6380394,1.92127107 59.6426436,1.85521676 59.6799916,1.79989673 C60.2201773,1.08762604 60.8884482,0.491805952 61.8950312,0.217072972 C62.7582145,-0.0237423563 63.6255744,0.0260035331 64.4901499,0.217072972 C65.4855951,0.434145944 66.4225667,0.782367169 67.3776372,1.08197309 C67.7450783,1.20235342 68.1217766,1.30318884 68.5053443,1.3838402 C69.2334812,1.53420845 69.8613774,1.37818725 70.4266232,1.00057073 C70.762075,0.76120257 71.0683852,0.496177303 71.341319,0.209158853 L71.5431925,0 Z"
                      id="Path"
                      stroke="#F58E1F"
                      fill="#F58E1F"></path>
                    <path
                      d="M41.3493018,0 C41.6793043,1.06608029 41.9996009,2.10166887 42.3198975,3.13612813 C42.3421808,3.18492203 42.3305289,3.23970597 42.2893931,3.27955207 C41.8124146,3.74935016 41.3382093,4.22253622 40.7045489,4.56359157 C39.7339531,5.08646781 38.68155,5.11695952 37.5958693,4.87076725 C36.9893611,4.71911609 36.4023934,4.51979406 35.8432506,4.27561437 C34.8726549,3.88373952 33.8743278,3.61721945 32.7803277,3.63867658 C32.087045,3.65222844 31.5462845,3.9232658 31.0984239,4.33659778 C30.8706789,4.55854209 30.6643878,4.79452366 30.4814023,5.04242424 C30.2886697,4.43033153 30.1042565,3.84760121 29.9267762,3.26487088 C29.7881196,2.8312111 29.6577825,2.396422 29.5205125,1.96276222 C29.4939824,1.90945941 29.4985722,1.84923208 29.5329916,1.79901049 C30.1306013,1.00509688 30.8918257,0.365900438 32.0565406,0.135518681 C32.935623,-0.0383969595 33.7925204,0.0711473073 34.6410985,0.281201262 C35.6269464,0.52626421 36.5614915,0.880871424 37.5251545,1.17223659 C37.8473257,1.27222772 38.1801208,1.3478353 38.5193218,1.39810106 C39.3165969,1.51103329 39.9308454,1.23660796 40.4785387,0.808594795 C40.7891294,0.571437103 41.0470305,0.291365163 41.3493018,0 Z"
                      id="Path"
                      stroke="#EE5123"
                      fill="#EE5123"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </p>
      </Flex>
    </div>
  );
};

const FiltersRow = ({
  onChange,
  dates,
  onClick,
  searchText,
  statuses,
  selectedStatus,
  entityTypeOptions,
  selectedEntity,
}) => {
  const [showDate, setShowDate] = useState(false);
  const toggleDate = () => {
    setShowDate(!showDate);
  };
  const onSelect = dates => {
    onChange('date', {
      startDate: moment(dates.start).format('MM-DD-YYYY'),
      endDate: moment(dates.end).format('MM-DD-YYYY'),
      dates,
    });
    toggleDate();
  };
  const handleClear = () => {
    setShowDate(false);
    onClick('clearFilter');
  };
  const formatDate = date => moment(date).format('MMM Do YY');
  return (
    <div className={styles.filterContainer}>
      <div className={styles.dropdown}>
        <Select
          options={(statuses || []).map(option => ({
            value: option.id,
            label: option.name,
          }))}
          placeholder={'Status'}
          styles={customStyles}
          value={
            selectedStatus
              ? (statuses || [])
                .map(option => ({
                  value: option.id,
                  label: option.name,
                }))
                .find(o => o.value === selectedStatus.id)
              : null
          }
          onChange={value => onChange('status-dropdown', value.value)}
        />
        <Select
          options={(entityTypeOptions || []).map(option => ({
            value: option.id,
            label: option.name,
          }))}
          placeholder={'Select Type'}
          styles={customStyles}
          value={
            selectedEntity
              ? (entityTypeOptions || [])
                .map(option => ({
                  value: option.id,
                  label: option.name,
                }))
                .find(o => o.value === selectedEntity.id)
              : null
          }
          onChange={value => onChange('entity-dropdown', value.value)}
        />
      </div>
      <Flex className={styles.searchBox}>
        <TextInput
          onChange={update => {
            onChange('search', update);
          }}
          value={searchText}
          isEdit={true}
          type={'text'}
          inputStyle={styles.inputText}
          showSeacrh={true}
          placeholder={'Search by Ref. Number or Phone Number'}
        />
      </Flex>
      <div className={styles.dateWrapper}>
        <div onClick={toggleDate} className={styles.inputDate}>
          {' '}
          <div>
            {' '}
            {dates
              ? formatDate(dates.start) + '-' + formatDate(dates.end)
              : strings.ADMIN.dateRange}
          </div>{' '}
          <img src={calendarBlue} className={styles.calendar} alt="C" />
        </div>
        {showDate ? (
          <div className={styles.datePicker}>
            <DateRangePicker
              numberOfCalendars={1}
              selectionType="range"
              onSelect={onSelect}
              className={styles.dateRange}
              value={dates}
              singleDateRange={true}
            />
          </div>
        ) : null}
      </div>
      <Flex onClick={handleClear} className={styles.clearLabel}>
        Clear
      </Flex>

      <Button
        onClick={() => onClick('apply')}
        buttonStyle="primary"
        label={strings.ADMIN.apply}
        className={styles.applyBtn}></Button>
    </div>
  );
};

const Header = () => {
  return (
    <Flex className={styles.headerContainer}>
      <ReactTooltip
        html={true}
        className={styles.toolTip}
        place="right"
        type="info"
        effect="solid"
        multiline={true}
        textColor="#fff"
        backgroundColor="#0045e6b3"
      />
      <Flex className={styles.headerInfo}>
        <div className={styles.headerText}>Registrations Requests</div>
        <div className={styles.info}>
          <img
            src={commonImages.infoIcon}
            alt="info"
            data-tip={strings.regRequest}
            width="20px"
          />
        </div>
      </Flex>
      {/* <Flex style={{alignItems: 'center'}}>
        <div className={styles.imageContainer}>
          <img src={bellIcon} className={styles.image} />
        </div>
        <img src={bgIcon} className={styles.image} />
      </Flex> */}
    </Flex>
  );
};

export default Desktop;
